import { IsNumber, Min, IsArray, ArrayMinSize, ArrayMaxSize, IsDefined } from 'class-validator';

export class ButtonSizeDto {
  @IsDefined()
  @IsArray()
  @ArrayMinSize(4)
  @ArrayMaxSize(4)
  @IsNumber({}, { each: true })
  @Min(0, { each: true })
  borderRadius!: [number, number, number, number];

  @IsDefined()
  @IsNumber()
  @Min(0)
  fontSize!: number;

  @IsDefined()
  @IsArray()
  @ArrayMinSize(4)
  @ArrayMaxSize(4)
  @IsNumber({}, { each: true })
  @Min(0, { each: true })
  padding!: [number, number, number, number];

  @IsDefined()
  @IsArray()
  @ArrayMinSize(4)
  @ArrayMaxSize(4)
  @IsNumber({}, { each: true })
  @Min(0, { each: true })
  margin!: [number, number, number, number];
}
